import React, { useState } from "react";
import MessageViewModal from "../Modal/MessageViewModal";
import { ChevronsUpDown, Eye, Loader, RotateCcw, X } from "lucide-react";
import {can_visit, usPhoneFormat} from "../../helpers";
import Skeleton from "react-loading-skeleton";
const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};
export default function BulkMessageDataTable(props) {
  const {
    tableData = [],
    handleCheckboxChange = () => {},
    handleSelectAll = () => {},
    selectAll = false,
    checkedIds = [],
    setCheckedIds = () => {},
    checkSelected = false,
    reloadData = () => {},
    reloadDataFilter = {},
    dataLoading,
    setDataLoading = () => {},
    resendButtonLoader = false,
    resendMessages = () => {},
    globalCheckedIds,
    setGlobalCheckedIds
  } = props;

  const LimitText = ({ text, limit }) => {
    if (text.length <= limit) {
      return text;
    } else {
      const limitText = text.substring(0, limit) + "...";
      return limitText;
    }
  };

  const [orderBy, setOrderBy] = useState();
  const [activeModal, setActiveModal] = useState(false);
  const [detailsData, setDetailsData] = useState(null);
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] === name) {
      if (reloadDataFilter.order_by[1] === "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };

  const removeSelection = () => {
    setCheckedIds([]);
    setGlobalCheckedIds(new Set());
  };

  const handleNoteView = (details) => {
    setDetailsData(details);
    setActiveModal(!activeModal);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
  }
  
  return (
    <>
      {(checkSelected && can_visit('messages_message_transaction_retry')) && (
        <>
          <hr />
          <div className="docpro_data_table_btns">
            {can_visit('messages_message_transaction_retry') && (
              <button 
                className="docpro_bordered_btn docpro_fw_600 docpro_primary_color"
                onClick={resendMessages}
                disabled = {resendButtonLoader ? true : false}
              >
                <RotateCcw width={20} height={20} />
                Resend Message
                {resendButtonLoader && (
                  <span className="docpro_loading">
                    <Loader width={20} height={20} />
                  </span>
                )}
              </button>
            )}
            {checkedIds?.length > 0 && (
              <div className='docpro_filtered_badge' style={{ margin: 0 }}>
                <span><b>Selected Messages</b>: {checkedIds?.length}</span>
                <button
                  onClick={removeSelection}
                >
                  <X width={18} height={18} />
                </button>
              </div>
            )}
          </div>
        </>
      )}

      <div className="docpro_table_responsive" style={{ minHeight: "250px" }}>
        <table className="docpro_mb_0">
          <thead>
            <tr>
              <th style={{ width: "45px" }}>
                <div className="docpro_checkbox" style={{ top: "3px" }}>
                  <input
                    type="checkbox"
                    checked={tableData.length > 0 && tableData.every((row) => globalCheckedIds?.has(row?.id))}
                    onChange={handleSelectAll}
                    disabled={tableData.length === 0}
                  />
                  <label></label>
                </div>
              </th>
              {/* <th>ID</th> */}
              
              {can_visit("_role_enterprise") && (
                <>
                  {/* <th 
                    onClick={() => {
                      handleOrderChange("account_name");
                    }}
                    className={orderBy === "account_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Practice Name <ChevronsUpDown size={"12"} />
                    </div>
                  </th>
                  <th 
                    onClick={() => {
                      handleOrderChange("location_name");
                    }}
                    className={orderBy === "location_name" ? "docpro_accent_color" : ""}
                  >
                    <div style={styles}>
                      Location <ChevronsUpDown size={"12"} />
                    </div>
                  </th> */}
                  <th> Practice Name </th>
                  <th> Location </th>
                </>
              )}
              <th
                onClick={() => {
                  handleOrderChange("notification_type");
                }}
                className={
                  orderBy === "notification_type" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Message Type <ChevronsUpDown size={"12"} />
                </div>
              </th>

              <th
                onClick={() => {
                  handleOrderChange("receiver_address");
                }}
                className={
                  orderBy === "receiver_address" ? "docpro_accent_color" : ""
                }
              >
                <div style={styles}>
                  Phone <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th>Message Body</th>

              <th
                onClick={() => {
                  handleOrderChange("status");
                }}
                className={orderBy === "status" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Status <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th>Segment</th>
              <th
                onClick={() => {
                  handleOrderChange("created_at");
                }}
                className={orderBy === "created_at" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Create Time <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th className="docpro_text_center">Action</th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id}`}>
                    <td style={{ width: "45px" }}>
                      <div className="docpro_checkbox" style={{ top: "3px" }}>
                        <input
                          type="checkbox"
                          checked={globalCheckedIds.has(item.id)}
                          onChange={() => handleCheckboxChange(item.id, item)}
                        />
                        <label></label>
                      </div>
                    </td>
                    {/* <td>{item.id}</td> */}
                    {can_visit("_role_enterprise") && (
                      <>
                        <td> {item.accountName} </td>
                        <td> {item.locationName} </td>
                      </>
                    )}
                    <td>{item.notificationType}</td>
                    <td>{usPhoneFormat(item.receiverAddress)}</td>
                    <td>
                      <LimitText text={item.messageBody} limit={30} />
                    </td>
                    <td>{item.status}</td>
                    <td>{item.segment}</td>
                    <td>{item.createdAt}</td>
                    <td>
                      <div className="docpro_icon_btns">
                        <button
                          className="docpro_icon_btn"
                          onClick={() => handleNoteView(item)}
                        >
                          <Eye width={20} height={20} />
                          <span className="docpro_tip">View Message</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "250px" }} colSpan={`${can_visit("_role_enterprise") ? 10 : 8}`}>
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  <td style={{ width: "45px" }}> <Skeleton width="1.2rem" borderRadius="8px"></Skeleton> </td>
                  {can_visit("_role_enterprise") && (
                    <>
                      <td> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                      <td> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                    </>
                  )}
                  <td> <Skeleton width={`${3 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="6rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${2 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="3rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5.5 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td className="text-center"> <Skeleton width="3rem" borderRadius="8px"></Skeleton> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {activeModal && (
        <MessageViewModal
          activeModal={activeModal}
          setActiveModal={setActiveModal}
          message_body={detailsData?.messageBody}
          segment={detailsData?.segment}
          previousScrollPosition={previousScrollPosition}
        />
      )}
    </>
  );
}
